import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateUserAddressEntity } from '../../domain/entities/UpdateUserAddressEntity'
export class UpdateUserAddressModel extends UpdateUserAddressEntity {
  constructor(dataDto: UpdateUserAddressEntity) {
    super()
    mapEntityProperties<UpdateUserAddressModel>(this, dataDto)
  }
}
